import Vue from 'vue';
import Vuex from 'vuex';
// import SharedState from 'vuex-multi-tab-state';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    backgroundColor: 'E0ECF8', //was orignally 'white', but i saw more references to this as a fallback
    versions: [],
    preferredDateFormat: 'dd-MM-yyyy',
    preferredJobOrder: '0',
    loggedInAccounts: [],
    //divider symbol, decimal symbol, decimal precision
    weightFormat: ',.4',
    volumeFormat: ',.4',
    currencyFormat: ',.2',
    masterCodeFileFormat: { noSpace: true },
    masterFileNameFormat: { toUpper: true },

    dashboard: null,
    loginDetails: null,
  },
  mutations: {
    updateBackgroundColor(state, color) {
      // color will be in string of any color that you like
      state.backgroundColor = color;
    },
    updateVersion(state, versions) {
      // all the versions in the version format (array)
      state.versions = versions;
    },
    updatePreferredDateFormat(state, dateFormat) {
      state.preferredDateFormat = dateFormat;
    },
    updatePreferredJobOrder(state, JobOrder) {
      state.preferredJobOrder = JobOrder;
    },
    updateLoggedInAccounts(state, accounts) {
      if (Array.isArray(accounts)) {
        state.loggedInAccounts = accounts;
      } else {
        state.loggedInAccounts.push(accounts);
        // accounts.forEach(a => state.loggedInAccounts.push(a));
      }
    },

    //For weight, volume, currency first two characters should exist
    //User preferred format might not have the precision, so we keep the existing precision
    //Thought about saving in the precision for user preferred for a more consistent code
    //Since it's not really controlled by the user, future updates to the precision might be troublesome. User will have to save again
    updateWeightFormat(state, weightFormat) {
      state.weightFormat =
        weightFormat.substring(0, 2) + (weightFormat?.substring(2) || state.weightFormat?.substring(2));
    },
    updateVolumeFormat(state, volumeFormat) {
      state.volumeFormat =
        volumeFormat.substring(0, 2) + (volumeFormat?.substring(2) || state.volumeFormat?.substring(2));
    },
    updateCurrencyFormat(state, currencyFormat) {
      state.currencyFormat =
        currencyFormat.substring(0, 2) + (currencyFormat?.substring(2) || state.currencyFormat?.substring(2));
    },

    updateMasterCodeFileFormat(state, noSpace) {
      state.masterCodeFileFormat.noSpace = noSpace === '1';
    },
    updateMasterFileNameFormat(state, toUpper) {
      state.masterFileNameFormat.toUpper = toUpper === 'Y';
    },

    updateDashboard(state, dashboard) {
      state.dashboard = dashboard;
    },

    updateLoginDetails(state, details) {
      state.loginDetails = details;
    },
  },
  // plugins: [
  //   SharedState()
  // ]
});
